/**
 * Canonical channel column order for the Programmplan day view (JIRA
 * "Sendungen nach Kanal in Spalten gruppieren"): main channels first
 * (ORF1, ORF2, ORFIII, ORF Sport+, ORF KIDS), then the Bundesländer.
 * Matches the channel set requested from the backend — keep both in sync
 * via CHANNEL_ORDER_CSV.
 */
export const CHANNEL_ORDER: readonly string[] = [
  'ORF1', 'ORF2', 'ORF3', 'ORFS', 'KIDS',
  'ORF-W', 'ORF-NOE', 'ORF-OOE', 'ORF-S', 'ORF-T',
  'ORF-V', 'ORF-K', 'ORF-ST', 'ORF-B', 'ORF-SI',
];

export const CHANNEL_ORDER_CSV = CHANNEL_ORDER.join(',');

/** Sort key into CHANNEL_ORDER; channels not in the list sort last. */
export function channelSortIndex(channel: string): number {
  const i = CHANNEL_ORDER.indexOf(channel);
  return i === -1 ? CHANNEL_ORDER.length : i;
}
